import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/StoresService';
import { StoresRepository } from '~repositories/StoresRepository';
import { StoresMap } from '~domain/entities/StoresMap';
import { Config } from '~domain/entities/Config';
import { when } from 'mobx';

export class StoreItemSelectedUseCase {
    private storesRepository: StoresRepository;
    private storesMap: StoresMap;
    private config: Config;
    private storeId: string;

    constructor(storeId: string) {
        this.storeId = storeId;
        this.storesMap = diContainer.get(serviceNames.storesMap);
        this.config = diContainer.get(serviceNames.config);
        this.storesRepository = diContainer.get(serviceNames.storesRepository);
    }

    public execute = async () => {
        const store = this.storesRepository.stores.find(
            (storeToFind) => storeToFind.id === this.storeId
        );
        const isMapEnabled = this.config?.config?.featureFlags?.mapEnabled ?? true;

        if (!isMapEnabled) {
            this.storesRepository.setSelectedStoreId(this.storeId);

            return;
        }

        if (store) {
            this.storesRepository.setSelectedStoreId(this.storeId);
            const { lat, lon } = store.geographical.coordinates;
            await when(() => !!this.storesMap.map);

            this.storesMap.map.panTo({
                latitude: lat,
                longitude: lon
            });
            this.storesMap.updateMapCenter({
                lat: String(lat),
                lng: String(lon)
            });
        }
    };
}
